<template>
  <div class="item">
    <div class="user">
      <div class="user_img">
        <img :src="userImg" alt v-if="userImg" />
        <img alt src="../../../../ui/LianPoH5/images/default_img.png" v-else/>
        <img alt src="../../../../ui/LianPoH5/images/team_going_add.png"/>
      </div>
      <div
        class="user_name" style="line-height: 0.6rem;"
      >{{ userName || "峡谷召唤师" }}</div>
    </div>
    <div class="right">
      <div class="text">
        <p class="human">
          还差
          <span>{{minJoinNum-stranger[2]}}</span>人
        </p>
        <p class="time">
          <CountDown :end-time="stranger[3]"></CountDown>
        </p>
      </div>
      <div @click="juonTuan(stranger)" class="btn">立即参团</div>
    </div>
  </div>
</template>

<script>
import CountDown from "./CountDown.vue"
export default {
  name: "StrangerItem",
  props: ["stranger", "minJoinNum", "juonTuan"],
  components: {
    CountDown
  },
  computed: {
    userName() {
      let name = ""
      try {
        name = decodeURIComponent(
          decodeURIComponent(this.stranger[1])
            .split("&")[0]
            .split("=")[1]
        )
      } catch (error) {
        // 有默认值
        console.log(error)
      }
      return name
    },
    userImg() {
      let img = ""
      try {
        img = decodeURIComponent(
          decodeURIComponent(this.stranger[1])
            .split("&")[1]
            .split("=")[1]
        )
      } catch (error) {
        // 有默认值
        console.log(error)
      }
      return img
    }
  }
}
</script>
